import React, { useEffect, useState } from "react";
import { Drawer, Row, Col, TimePicker, Input, DatePicker } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { rejectTimeSheet } from "../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import "./drawer.css";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

const TopDrawer = (props) => {
  const [visible, setVisible] = React.useState(false);
  const [correctionReason, setCorrectionReason] = React.useState("");
  const [StartValue, setStartValue] = useState("");
  const [EndValue, setEndValue] = useState("");

  const loading = useSelector(state => state.rejectTimeSheetReducer.loading)

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    setVisible(props.open);
    setStartValue(props.startTime);
    setEndValue(props.endTime);
  }, [props]);


  useEffect(() => {
    setVisible(props.open)
  }, [props])

  // const showDrawer = () => {
  //     setVisible(props.open);
  // };
  const onClose = () => {
    setVisible(false);
    props.close(false);
  };
  return (
    <Drawer
      placement="top"
      onClose={onClose}
      visible={visible}
      className="request-correction-drawer"
    >
      <div className="drawer-time-container">
        <div className="start-time-div">
          <div className="time-label">
            Start time <b style={{ color: "#db2828" }}>*</b>
          </div>
          <div className="time-div">
            <DatePicker
              className="timepicker"
              picker="time"
              defaultValue={moment(props.startTime, "HH:mm a")}
              format="h:mm a"
              use12Hours={true}
              onChange={(time, timeString) => setStartValue(timeString)}
              disabledDate={(current) => {
                return moment().add(-1, "days") >= current;
              }}
            />
          </div>
        </div>
        <div className="end-time-div">
          <div className="time-label">
            End time <b style={{ color: "#db2828" }}>*</b>
          </div>
          <div className="time-div">
            <DatePicker
              className="timepicker"
              picker="time"
              defaultValue={moment(props.endTime, "HH:mm a")}
              format="h:mm a"
              use12Hours={true}
              onChange={(time, timeString) => setEndValue(timeString)}
              disabledDate={(current) => {
                return moment().add(-1, "days") >= current;
              }}
            />
          </div>
        </div>
      </div>
      <div className="reason-textarea-div">
        <div className="time-label">
          Reason for correction <b style={{ color: "#db2828" }}>*</b>
        </div>
        <TextArea
          rows={4}
          showCount
          maxLength={150}
          onChange={(t) => setCorrectionReason(t.target.value)}
        />
        {/* <Input type='textarea' showCount maxLength={150}/> */}
      </div>

      <button
        className="send-for-correction-btn"
        onClick={() =>
          dispatch(
            rejectTimeSheet({
              Date: props.date,
              TimeSheetId: props.id,
              StartTime: StartValue.toUpperCase(),
              EndTime: EndValue?.toUpperCase(),
              Reason: correctionReason,
              Status: "Pending",
            })
          )
        }
      >
        {loading ? <LoadingOutlined /> : 'Send Request'}
      </button>
    </Drawer>
  );
};
export default TopDrawer;
